import React from 'react';
import { FiAward, FiTrendingUp, FiCheck } from 'react-icons/fi';

const Success = () => {
  const caseStudies = [
    {
      client: 'Shree Krishna Hanuman Press Chakan',
      industry: 'Printing Press',
      challenge:
        'Frequent equipment breakdowns due to scale buildup in printing machines, resulting in 30% production downtime and high maintenance costs.',
      solution:
        'Implemented RU DSA-6 descaling solution with a scheduled maintenance program.',
      results: [
        'Reduced downtime from 30% to 5%',
        'Extended equipment life by 45%',
        'Saved $50,000 annually in maintenance costs',
        'Improved production efficiency by 28%',
      ],
      image: 'https://images.unsplash.com/photo-1567789884554-0b844b597180?w=600&h=400&fit=crop',
    },
    {
      client: 'Mahindra and Mahindra',
      industry: 'Automotive Manufacturing',
      challenge:
        'Corrosion issues with stored equipment and safety concerns due to flammable rust preventives.',
      solution:
        'Switched to RU ORA-7 non-flammable rust preventive oil for all machinery protection needs.',
      results: [
        'Eliminated safety hazards completely',
        'Reduced rust-related damage by 90%',
        'Extended storage protection to 12 months',
        'Improved worker safety compliance',
      ],
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&h=400&fit=crop',
    },
    {
      client: 'Ashok Leyland',
      industry: 'Commercial Vehicles',
      challenge:
        'Scale buildup in cooling systems and engine components, affecting vehicle performance and increasing maintenance costs.',
      solution:
        'Applied RU DSA-6 descaling solution across cooling systems with a preventive maintenance program.',
      results: [
        'Improved engine cooling efficiency by 85%',
        'Reduced scale-related breakdowns by 95%',
        'Extended component life significantly',
        'Enhanced overall vehicle performance and reliability',
      ],
      image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=600&h=400&fit=crop',
    },
    {
      client: 'Maharashtra State Electricity Company',
      industry: 'Power Generation',
      challenge:
        'Heavy scale deposits in cooling towers and condensers reducing power generation efficiency and increasing fuel consumption.',
      solution:
        'Implemented RU DSA-6 for systematic descaling of cooling systems and heat exchangers.',
      results: [
        'Restored cooling efficiency by 92%',
        'Reduced fuel consumption by 18%',
        'Extended equipment lifespan by 40%',
        'Minimized unplanned shutdowns significantly',
      ],
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&h=400&fit=crop',
    },
    {
      client: 'NTPC Power Plant Mauda',
      industry: 'Thermal Power',
      challenge:
        'Critical scale buildup in boiler tubes and heat exchangers affecting thermal efficiency and causing frequent maintenance shutdowns.',
      solution:
        'Deployed RU DSA-6 descaling solution with customized treatment protocols for high-temperature applications.',
      results: [
        'Improved thermal efficiency by 25%',
        'Reduced maintenance downtime by 60%',
        'Extended boiler tube life by 50%',
        'Achieved significant cost savings in operations',
      ],
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop',
    },
    {
      client: 'Ordnance Factory',
      industry: 'Defense Manufacturing',
      challenge:
        'Need for non-flammable, high-performance rust prevention solution for stored ammunition and equipment meeting strict safety standards.',
      solution:
        'Supplied RU ORA-7 non-flammable rust preventive oil meeting defense specifications and safety requirements.',
      results: [
        'Achieved 100% safety compliance',
        'Extended storage protection to 18 months',
        'Eliminated fire hazards completely',
        'Met all defense quality certifications',
      ],
      image: 'https://images.unsplash.com/photo-1565372195458-9de0b320ef04?w=600&h=400&fit=crop',
    },
  ];

  const testimonials = [
    {
      name: 'Rajesh Mehta',
      position: 'Plant Manager',
      company: 'Shree Krishna Hanuman Press Chakan',
      quote:
        "RU DSA-6 has been a game-changer for our operations. We have seen a dramatic reduction in equipment failures and our maintenance costs have dropped significantly. The VP Chem team provided excellent support throughout the implementation.",
      rating: 5,
    },
    {
      name: 'Sneha Patel',
      position: 'Operations Director',
      company: 'Mahindra and Mahindra',
      quote:
        'Switching to RU ORA-7 was one of the best decisions we made. Not only is it safer for our workers, but the long-lasting protection has exceeded our expectations. Highly recommended for any industrial application.',
      rating: 5,
    },
    {
      name: 'Arun Kumar',
      position: 'Maintenance Head',
      company: 'Ashok Leyland',
      quote:
        'RU DSA-6 delivered outstanding results for our cooling system maintenance. The descaling solution improved our engine performance significantly. The eco-friendly formulation gives us peace of mind. Outstanding product!',
      rating: 5,
    },
    {
      name: 'Pradeep Singh',
      position: 'Chief Engineer',
      company: 'Maharashtra State Electricity Company',
      quote:
        'VP Chem Technologies provided exceptional descaling solutions that significantly improved our power generation efficiency. The results exceeded our expectations and the team was highly professional throughout.',
      rating: 5,
    },
    {
      name: 'Dr. Suresh Patil',
      position: 'Technical Director',
      company: 'NTPC Power Plant Mauda',
      quote:
        'RU DSA-6 has proven to be highly effective for our critical thermal applications. The descaling performance is outstanding and has helped us achieve better operational efficiency with reduced downtime.',
      rating: 5,
    },
    {
      name: 'Colonel Vikram Rao',
      position: 'Quality Assurance Head',
      company: 'Ordnance Factory',
      quote:
        'RU ORA-7 meets all our stringent defense specifications and safety requirements. The non-flammable formulation provides excellent long-term protection for our equipment. Highly reliable product.',
      rating: 5,
    },
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-vp-cream-100 via-white to-vp-cream-200">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDEzNGg4djdoLTh6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-20"></div>
        
        <div className="relative container mx-auto px-4 lg:px-8 text-center">
          <div className="inline-flex items-center space-x-2 bg-vp-green-100 px-4 py-2 rounded-full text-vp-green-700 mb-6">
            <FiAward />
            <span className="text-sm font-medium">Client Success Stories</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-vp-grey-900 mb-6">
            Our Success Stories
          </h1>
          <p className="text-lg md:text-xl text-black max-w-3xl mx-auto">
            Real results from real clients across diverse industries
          </p>
        </div>
      </section>

      {/* Case Studies */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-vp-grey-900 mb-4">
              Case Studies
            </h2>
            <p className="text-lg text-black max-w-2xl mx-auto">
              Discover how our products have transformed operations for businesses like yours
            </p>
          </div>

          <div className="space-y-12 max-w-6xl mx-auto">
            {caseStudies.map((study, index) => (
              <div
                key={index}  
                className="bg-gradient-to-br from-vp-grey-50 to-white rounded-2xl overflow-hidden border-2 border-vp-grey-200 hover:border-vp-green-400 hover:shadow-xl transition-all duration-300"
              >
                <div className="md:flex">
                  <div className="md:w-1/3">
                    <img 
                      src={study.image} 
                      alt={study.client}
                      className="w-full h-64 md:h-full object-cover"
                    />
                  </div>
                  <div className="md:w-2/3 p-8 md:p-10">
                    <div className="mb-6">
                      <h3 className="text-2xl md:text-3xl font-bold text-vp-grey-900 mb-2">
                        {study.client}
                      </h3>
                      <span className="inline-block px-3 py-1 bg-vp-green-100 text-vp-green-700 text-sm font-semibold rounded-full">
                        {study.industry}
                      </span>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6 mb-6">
                      <div className="bg-red-50 rounded-xl p-6">
                        <h4 className="font-bold text-red-900 mb-2 flex items-center space-x-2">
                          <span className="text-red-600">⚠️</span>
                          <span>Challenge</span>
                        </h4>
                        <p className="text-sm text-red-800">{study.challenge}</p>
                      </div>

                      <div className="bg-blue-50 rounded-xl p-6">
                        <h4 className="font-bold text-blue-900 mb-2 flex items-center space-x-2">
                          <span className="text-blue-600">💡</span>
                          <span>Solution</span>
                        </h4>
                        <p className="text-sm text-blue-800">{study.solution}</p>
                      </div>

                      <div className="bg-green-50 rounded-xl p-6">
                        <h4 className="font-bold text-green-900 mb-2 flex items-center space-x-2">
                          <FiTrendingUp className="text-green-600" />
                          <span>Results</span>
                        </h4>
                        <ul className="space-y-1">
                          {study.results.map((result, idx) => (
                            <li key={idx} className="flex items-start space-x-2">
                              <FiCheck className="text-green-600 mt-0.5 flex-shrink-0 text-sm" />
                              <span className="text-xs text-green-800">{result}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-vp-grey-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-vp-grey-900 mb-4">
              Client Testimonials
            </h2>
            <p className="text-lg text-black max-w-2xl mx-auto">
              Hear what our satisfied clients have to say
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
              >
                <div className="flex space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-xl">★</span>
                  ))}
                </div>
                <p className="text-black italic mb-6 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-vp-grey-200 pt-4">
                  <p className="font-bold text-vp-grey-900">{testimonial.name}</p>
                  <p className="text-sm text-black">{testimonial.position}</p>
                  <p className="text-sm text-vp-green-600 font-semibold">
                    {testimonial.company}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-vp-green-600 to-vp-blue-600">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Write Your Success Story?
          </h2>
          <p className="text-lg text-white mb-8 max-w-2xl mx-auto">
            Join our growing list of satisfied clients and transform your operations today
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-white text-vp-green-600 font-semibold rounded-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200"
          >
            Get Started Today
          </a>
        </div>
      </section>
    </div>
  );
};

export default Success;



